import securityModals from "../../../../../../web-sh/src/pages/admin/settings/components/security/modals";
import ChangeMasterPasswordModal from "./ChangeMasterPassword";

const securityModalsComponents = {
  ...securityModals,
  ChangeMasterPasswordModal,
}

export default securityModalsComponents;